import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';

import { CounterpartyService } from '@shared/services';

import { CounterpartyDetailsActions } from './counterparty.actions';
import { selectRouteParams } from '../core';
import { MessagesActions } from '../core/messages';

export const loadCounterpartyDetails$ = createEffect(
  (actions$ = inject(Actions), counterpartyService = inject(CounterpartyService), store = inject(Store)) => {
    return actions$.pipe(
      ofType(CounterpartyDetailsActions.loadCounterpartyDetails),
      concatLatestFrom(() => [store.select(selectRouteParams)]),
      mergeMap(([, routeParams]) => {
        return counterpartyService.getCounterpartyById(routeParams.id).pipe(
          map((counterpartyDetails) => {
            return CounterpartyDetailsActions.loadCounterpartyDetailsSuccess({ counterpartyDetails });
          }),
          catchError((error) => {
            return of(CounterpartyDetailsActions.loadCounterpartyDetailsFailure({ error }));
          }),
        );
      }),
    );
  },
  { functional: true },
);

export const loadCounterpartyDetailsFailure$ = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(CounterpartyDetailsActions.loadCounterpartyDetailsFailure),
      switchMap(() => of(MessagesActions.displayError({ message: 'Unable to fetch Counterparty Details.' }))),
    );
  },
  { functional: true },
);
